const organizations = {
    title: 'Organizações',
    description: 'Crie e gerencie as organizações das quais você faz parte.',
    create: 'Criar organização',
    create_title: 'Criar uma nova organização',
    name: 'Nome da organização',
    avatar: 'Avatar da organização',
    avatar_removed: 'Avatar da organização removido.',
    description_label: 'Descrição',
    empty: 'Você ainda não pertence a uma organização.',
    pending_invitations: 'Convites pendentes',
    accept: 'Aceitar',
    decline: 'Recusar',
    owner: 'Proprietário',
    tabs: {
        overview: 'Visão geral',
        members: 'Membros',
        invitations: 'Convites',
        roles: 'Funções de gestão',
        branding: 'Identidade visual',
        security: 'Segurança',
        jit: 'Provisionamento JIT',
        applications: 'Recursos compartilhados',
        activity: 'Atividade',
        deletion: 'Excluir',
    },
    members: {
        title: 'Membros',
        empty: 'Nenhum membro encontrado.',
        remove: 'Remover',
        removed: 'Membro removido.',
        business_roles: 'Funções de negócio',
        no_business_roles: 'Não há funções de negócio disponíveis. Peça ao administrador do tenant para compartilhar funções com esta organização.',
    },
    invitations: {
        title: 'Convites',
        invite: 'Convidar membro',
        email: 'Endereço de e-mail',
        empty: 'Nenhum convite encontrado.',
        resend: 'Reenviar',
        resent: 'Convite reenviado.',
        revoke: 'Revogar',
        revoked: 'Convite revogado.',
        status: {
            Pending: 'Pendente',
            Accepted: 'Aceito',
            Expired: 'Expirado',
            Revoked: 'Revogado',
            Declined: 'Recusado',
        },
    },
    roles: {
        title: 'Funções de gestão',
        create: 'Criar função',
        permissions: 'Permissões',
        empty: 'Nenhuma função de gestão encontrada.',
        select_member: 'Selecionar membro',
        select_role: 'Selecionar função',
        assign: 'Atribuir função',
        assigned: 'Função atribuída.',
        unassign: 'Remover função',
        unassigned: 'Função removida.',
        permission_count: 'Permissões: {{count}}',
        built_in: {
            owner: 'Proprietário',
            owner_description: 'Os proprietários têm controle exclusivo sobre a propriedade e a exclusão da organização.',
            administrator: 'Administrador',
            administrator_description: 'Gerencia a organização, exceto ações reservadas aos proprietários.',
        },
        permission_labels: {
            update_profile: 'Atualizar perfil',
            manage_branding: 'Gerenciar identidade visual',
            view_members: 'Ver membros',
            manage_members: 'Gerenciar membros',
            manage_invitations: 'Gerenciar convites',
            assign_business_roles: 'Atribuir funções de negócio',
            manage_management_roles: 'Gerenciar funções de gestão',
            assign_management_roles: 'Atribuir funções de gestão',
            manage_security: 'Gerenciar segurança',
            manage_jit: 'Gerenciar provisionamento JIT',
            manage_applications: 'Gerenciar aplicativos',
            view_activity: 'Ver atividade',
        },
    },
    branding: {
        title: 'Identidade visual da organização',
        primary_color: 'Cor principal',
        custom_css: 'CSS personalizado',
        preview: 'Prévia',
        light: 'Claro',
        dark: 'Escuro',
    },
    security: {
        title: 'Segurança da organização',
        require_mfa: 'Exigir autenticação multifator para membros',
    },
    jit: {
        title: 'Domínios de e-mail JIT',
        domain: 'Domínio de e-mail',
        add: 'Adicionar domínio',
        verify: 'Verificar DNS',
        dns_instruction: 'Crie o registro TXT {{record}} com o valor {{value}}.',
        verified: 'Verificado',
    },
    applications: {
        title: 'Recursos compartilhados',
        empty: 'Não há recursos disponíveis para esta organização.',
        sso: 'Conexões SSO empresariais',
        m2m: 'Aplicativos máquina a máquina',
    },
    activity: {
        title: 'Atividade da organização',
        empty: 'Ainda não há atividade.',
        events: {
            create: 'Organização criada',
            delete: 'Organização excluída',
            profile: 'Perfil da organização atualizado',
            branding: 'Identidade visual atualizada',
            security: 'Segurança da organização atualizada',
            member_add: 'Membro adicionado',
            member_remove: 'Membro removido',
            owner: 'Propriedade da organização atualizada',
            role_create: 'Função de gestão criada',
            role_update: 'Função de gestão atualizada',
            role_delete: 'Função de gestão excluída',
            role_assign: 'Função de gestão atribuída',
            role_unassign: 'Função de gestão removida do membro',
            business_role: 'Funções de negócio atualizadas',
            invitation_create: 'Convite enviado',
            invitation_accept: 'Convite aceito',
            invitation_decline: 'Convite recusado',
            invitation_revoke: 'Convite revogado',
            jit: 'Provisionamento JIT atualizado',
            domain: 'Verificação do domínio de e-mail',
            application: 'Conexões de aplicativos atualizadas',
            unknown: 'Atividade da organização',
        },
    },
    save: 'Salvar alterações',
    cancel: 'Cancelar',
    delete: 'Excluir organização',
    delete_confirmation: 'Esta ação exclui permanentemente a organização e seus vínculos de membros. Digite “{{name}}” para confirmar.',
    deleted: 'Organização excluída.',
    load_failed: 'Não foi possível carregar os dados da organização. Tente novamente.',
    permission_denied: 'Você não tem permissão para ver esta seção.',
};
export default organizations;
